export default __webpack_public_path__ + "static/media/RWWA.65c97d99.svg";